import axios from 'axios'
import { WX_JSSDK_CONFIG, WX_AUTHORIZE } from '@/assets/scripts/api'
import store from '@/store'
import Cookies from 'js-cookie'

/**************************** private method ************************************/
function str2asc (str) {
  return str.charCodeAt(0).toString(16)
}

function asc2str (str) {
  return String.fromCharCode(str)
}

/**
 * UrlDecode函数
 * @return {string}
 */
export const UrlDecode = function (str) {
  let asc, chr, ret
  ret = ''
  for (let i = 0; i < str.length; i++) {
    chr = str.charAt(i)
    if (chr === '+') {
      ret += ' '
    } else if (chr === '%') {
      asc = str.substring(i + 1, i + 3)
      if (parseInt('0x' + asc) > 0x7f) {
        ret += asc2str(parseInt('0x' + asc + str.substring(i + 4, i + 6)))
        i += 5
      } else {
        ret += asc2str(parseInt('0x' + asc))
        i += 2
      }
    } else {
      ret += chr
    }
  }
  return ret
}

/**
 * UrlEncode函数
 * @return {string}
 */
export const UrlEncode = function (str) {
  let chr, ret, c
  ret = ''
  let strSpecial = '!"#$%&\'()*+,/:;<=>?[]^`{|}~%'
  for (let i = 0; i < str.length; i++) {
    chr = str.charAt(i)
    c = str2asc(chr)
    if (parseInt('0x' + c) > 0x7f) {
      ret += '%' + c.slice(0, 2) + '%' + c.slice(-2)
    } else {
      if (chr === ' ') {
        ret += '+'
      } else if (strSpecial.indexOf(chr) !== -1) {
        ret += '%' + c.toString(16).toUpperCase()
      } else {
        ret += chr
      }
    }
  }
  return ret
}

export const IsWechat = () => {
  return window.navigator.userAgent.toLowerCase().indexOf('micromessenger') >= 0
}

export const wxOAuth = function (REDIRECT, STATE) {
  return (function () {
    let mm, r
    let rquery = /\?/
    if (!IsWechat() || !store.state.center.wxAppId) {
      mm = (REDIRECT || '').split('#')
      r = mm.length > 1 ? mm[1] : mm[0]
      return REDIRECT + (rquery.test(r) ? '&' : '?') + 'state=' + (STATE || '')
    } else {
      return 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + store.state.center.wxAppId + '&times=' + new Date().getTime() + '&redirect_uri=' + UrlEncode(REDIRECT) + '&response_type=code&scope=snsapi_base&state=' + (STATE || '') + '#wechat_redirect'
    }
  })()
}

export const scan = () => {
  window.wx.scanQRCode({
    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
    scanType: ['barCode'], // 可以指定扫二维码还是一维码，默认二者都有
    success: function (res) {
      return res
      // var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
    }
  })
}
/**
 * 获取微信前端页面跳转授权地址
 * @param REDIRECT 授权后跳转的地址
 * @param STATE 附加参数
 * @param USER_INFO 是否获取用户信息 true获取用户信息,false为不获取
 * @returns {String} 返回授权的URL地址
 * @constructor
 */
export const WxOAuth2 = function (REDIRECT, STATE, USER_INFO) {
  return (function () {
    let mm, r
    let rquery = /\?/
    if (!IsWechat() || !store.state.center.wxAppId) {
      mm = (REDIRECT || '').split('#')
      r = mm.length > 1 ? mm[1] : mm[0]
      return REDIRECT + (rquery.test(r) ? '&' : '?') + 'state=' + (STATE || '')
    } else {
      return 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + store.state.center.wxAppId + '&redirect_uri=' + UrlEncode(WX_AUTHORIZE + '?forward=' + encodeURIComponent(REDIRECT) + (USER_INFO ? '&user_info=1' : '')) + '&response_type=code&scope=snsapi_userinfo&state=' + (STATE || '') + '#wechat_redirect'
    }
  })()
}

/**
 * 获取微信前端页面跳转授权地址
 * @param REDIRECT 授权后跳转的地址
 * @param sysCenterId 是否获取用户信息 true获取用户信息,false为不获取
 * @returns {String} 返回授权的URL地址
 * @constructor
 */
export const WxOAuthLogin = function (REDIRECT, sysCenterId) {
  window.location.replace(store.state.wxContentUrl + `/wx?sysCenterId=${sysCenterId || '00-0'}&uri=${window.encodeURIComponent(REDIRECT)}`)
}

/**
 * 初始化微信js sdk config
 * @param sid 体检中心ID
 * @constructor
 */
export const InitWxConfig = async function (sid) {
  let url = window.location.href
  url = encodeURIComponent(url)
  let {data} = await axios.get(WX_JSSDK_CONFIG, {params: {sid: '00-0', url: url}})
  console.log(JSON.stringify(data))
  store.commit('center/setWxAppId', data.data.appid)
  window.wx.config({
    //debug: true,
    appId: data.data.appid, // 必填，公众号的唯一标识
    timestamp: data.data.timestamp, // 必填，生成签名的时间戳
    nonceStr: data.data.noncestr, // 必填，生成签名的随机串
    signature: data.data.signature, // 必填，签名，见附录1
    jsApiList: [
      'checkJsApi',
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'onMenuShareWeibo',
      'hideMenuItems',
      'showMenuItems',
      'hideAllNonBaseMenuItem',
      'showAllNonBaseMenuItem',
      'translateVoice',
      'startRecord',
      'stopRecord',
      'onRecordEnd',
      'playVoice',
      'pauseVoice',
      'stopVoice',
      'uploadVoice',
      'downloadVoice',
      'chooseImage',
      'previewImage',
      'uploadImage',
      'downloadImage',
      'getLocalImgData',
      'getNetworkType',
      'openLocation',
      'getLocation',
      'hideOptionMenu',
      'showOptionMenu',
      'closeWindow',
      'scanQRCode',
      'chooseWXPay',
      'openProductSpecificView',
      'addCard',
      'chooseCard',
      'openCard'
    ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  })
}
